module.exports = __webpack_public_path__ + "static/media/three.bf6e44b1.png";